export default __webpack_public_path__ + "static/media/unpackicon.a8dbab0a.png";